import React from 'react';
import Heading from '../../components/Typography/Heading/Heading';
import SubHeading from '../../components/Typography/SubHeading/SubHeading';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import { getURLTickers } from '../ProfileScreen/util';
import styles from './styles.css';
import { navigateToLoginFromChecklist } from './utils';
import { redirectToAccountFinder } from '../../flows/shared/utils';

const StepsSection = () => {
  return (
    <>
      <section>
        <div className="checklist-section-title">
          Opening an account takes 5-10 minutes:
        </div>
        <dl>
          <ol>
            <li aria-describedby="basic-investment-info">
              <dt data-name="1">Provide basic investment details</dt>
              <dd id="basic-investment-info">
                This helps us tailor your investment options.
              </dd>
            </li>
            <li aria-describedby="trust-investment-info">
              <dt data-name="2">Choose Mutual Funds for your Trust</dt>
              <dd id="trust-investment-info">
                Explore all{' '}
                <a
                  href="https://www.troweprice.com/personal-investing/tools/fund-research"
                  target="_blank"
                  rel="noopener noreferrer">
                  T. Rowe Price Mutual Funds.
                </a>
              </dd>
            </li>
            <li aria-describedby="trust-trustee-info">
              <dt data-name="3">
                Provide information about the Trust and personal details as the
                Trustee
              </dt>
              <dd id="trust-trustee-info">
                We&apos;ll use these to secure and verify the account.
              </dd>
            </li>
            <li className="mailbox" aria-describedby="mail-check-info">
              <dt data-name="4">Mail us a check</dt>
              <dd id="mail-check-info">
                Once your account is established, mail us a check to fund your
                account.
              </dd>
            </li>
          </ol>
        </dl>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

export const ChecklistSection = () => {
  return (
    <>
      <section>
        <div className="checklist-section-title">You will need:</div>
        <ul>
          <li>A minimum of $2,500</li>
          <li>Name and address of the Trust</li>
          <li>Trust Identification Number and Date of Trust</li>
          <li>Trustee&apos;s Social Security number</li>
          <li>Trustee&apos;s permanent U.S. residence</li>
        </ul>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

const TrustChecklistScreen = ({ appState, next }) => {
  const {
    store: { authenticated }
  } = appState;

  // multi-fund buy query check
  // capture tickers to pass to InvestmentReviewScreen
  const multiBuyTickers = getURLTickers(window.location.search);

  return (
    <div className="checklist-screen">
      <Heading text="Open a Trust account" />
      <SubHeading text="Support your estate plan and open this account in the name of an established trust" />

      <div className="qv-row">
        <div className="qv-col col-left">
          <StepsSection />
        </div>

        <div className="qv-col col-right">
          <ChecklistSection />
        </div>
      </div>

      <div className="button-container">
        {authenticated ? (
          <MFBeaconButton
            variant="primary"
            size="normal"
            id="checklistContinueExisting"
            className="beacon-button-margin-override"
            onClick={next(multiBuyTickers)}
            label="Continue Opening an Account"
            data-name="trustChecklistContinue"
          />
        ) : (
          <div className="login-buttons">
            <MFBeaconButton
              variant="primary"
              size="normal"
              id="checklistLogin"
              className="beacon-button-margin-override"
              onClick={() => navigateToLoginFromChecklist('/profile')}
              label="Already a Client? Log In to Continue"
              data-name="trustChecklistLogin"
            />
            <MFBeaconButton
              variant="secondary"
              size="normal"
              id="checklistContinueNew"
              className="beacon-button-margin-override"
              onClick={next(multiBuyTickers)}
              label="New to T. Rowe Price? Start Now"
              data-name="trustChecklistNewStart"
            />
          </div>
        )}
        <MFBeaconButton
          variant="tertiary"
          size="normal"
          id="checklistBack"
          className="beacon-button-margin-override"
          onClick={redirectToAccountFinder}
          label="Back"
        />
      </div>
      <PhoneNumber />
      <style jsx>{styles}</style>
    </div>
  );
};

export default TrustChecklistScreen;
